module.exports = __webpack_public_path__ + "media/images/icon/toast-danger-52b6113170abd1f4bd3ba022d3dee0db.png";